var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDropDocs = function SvgDropDocs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m32 33.563 11.314 11.312-3.773 3.774-4.875-4.875v14.893h-5.333V43.77l-4.875 4.88-3.773-3.774L32 33.563Zm0-28.229a18.67 18.67 0 0 1 18.544 16.517 14.667 14.667 0 0 1-2.542 28.758v-5.371a9.335 9.335 0 0 0 6.605-14.171 9.333 9.333 0 0 0-9.57-4.256 13.333 13.333 0 1 0-26.072 0 9.333 9.333 0 1 0-3.445 18.347l.48.08v5.37a14.667 14.667 0 0 1-2.544-28.757A18.667 18.667 0 0 1 32 5.334Z"
  })));
};
export default SvgDropDocs;